export enum NotificationType {
    Success = 'success',
    Warning = 'warning',
    Error = 'error',
    Info = 'info',
    Fail = 'fail'
}